var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"img-con"},[_c('img-zoom',{attrs:{"src":"src/img/img-samll.png","bigsrc":"src/img/img-big.jpg"}})],1),_vm._v(" "),_c('div',{staticClass:"img-con2"},[_c('img-zoom',{attrs:{"src":"src/img/img-samll.png","width":"450","height":"250","bigsrc":"src/img/img-big.jpg","configs":_vm.configs}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-4fb1f1a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 21
// module chunks = 0